// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 239
// module chunks = 0